import { apiGet, apiPost } from './api';

export type Notification = {
  id: number;
  kind: string;
  deal_id: number | null;
  title: string;
  body: string | null;
  at: string;
  unread: boolean;
};

export const getNotifications = () =>
  apiGet<{ notifications: Notification[]; unread: number }>('/api/notifications');

export const markNotificationsRead = () =>
  apiPost<{ ok: boolean; unread: number }>('/api/notifications/read');
